var map = {
	"./54_hamster.mp3": "9b5f",
	"./55_parrot.mp3": "ef70",
	"./56_canary.mp3": "65f1",
	"./M_Brilliant.mp3": "ee1e",
	"./M_Excellent.mp3": "e492",
	"./M_Fantastic.mp3": "f082",
	"./M_Great.mp3": "22ee",
	"./M_Perfect.mp3": "5239",
	"./M_Think again.mp3": "b9c3",
	"./M_Try again.mp3": "3b7ad",
	"./M_Very good.mp3": "18a4",
	"./M_Well done.mp3": "7bc7",
	"./M_Work harder.mp3": "2d01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f9fb";